import Affids from "./Affids";
import Report from "./Report";

export default { Affids, Report };


// WEBPACK FOOTER //
// ./src/services/API/components/PropellerAds/index.js